module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-play-e02b81be.svg";